import React from 'react';

const SystemAdministrators = ({ adminUsers, users, user, promoteUser, demoteUser }) => {
  return (
    <section className="rounded-lg border border-purple-200 bg-purple-50 p-6 shadow-sm">
      <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-xl font-semibold text-purple-900">System Administrators</h2>
          <p className="mt-1 text-sm text-purple-700">Manage system-wide administrative access</p>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="mobile-table min-w-full divide-y divide-purple-200">
          <thead className="bg-purple-100">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-purple-700">
                ID
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-purple-700">
                Name
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-purple-700">
                Email
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-purple-700">
                Status
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider text-purple-700">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-purple-200">
            {adminUsers.map((admin) => (
              <tr key={admin.id}>
                <td className="whitespace-nowrap px-4 py-2 text-sm text-gray-900" data-label="ID">
                  {admin.id}
                </td>
                <td className="whitespace-nowrap px-4 py-2 text-sm text-gray-900" data-label="Name">
                  {admin.first_name} {admin.last_name}
                </td>
                <td
                  className="whitespace-nowrap break-words px-4 py-2 text-sm text-gray-900"
                  data-label="Email"
                >
                  {admin.email}
                </td>
                <td
                  className="whitespace-nowrap px-4 py-2 text-sm text-gray-900"
                  data-label="Status"
                >
                  <span
                    className={`rounded px-2 py-1 text-xs font-semibold ${admin.is_active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-700'}`}
                  >
                    {admin.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td
                  className="space-x-3 whitespace-nowrap px-4 py-2 text-sm text-gray-900"
                  data-label="Actions"
                >
                  {admin.id !== user.id && (
                    <button
                      className="text-red-600 hover:underline"
                      onClick={() => demoteUser(admin)}
                    >
                      Demote from Admin
                    </button>
                  )}
                  {admin.id === user.id && (
                    <span className="italic text-gray-500">Current User</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-4">
        <h3 className="text-md mb-2 font-medium text-purple-900">Promote User to Admin</h3>
        <div className="flex gap-2">
          <select
            className="rounded border border-purple-300 px-3 py-2 text-sm"
            onChange={(e) => {
              const selectedUser = users.find((u) => u.id === parseInt(e.target.value));
              if (selectedUser) {
                promoteUser(selectedUser);
                e.target.value = '';
              }
            }}
            defaultValue=""
          >
            <option value="" disabled>
              Select a user to promote...
            </option>
            {users
              .filter((u) => !u.is_admin)
              .map((u) => (
                <option key={u.id} value={u.id}>
                  {u.first_name} {u.last_name} ({u.email})
                </option>
              ))}
          </select>
        </div>
      </div>
    </section>
  );
};

export default SystemAdministrators;
